

/** @type {import('./max')} */
module.exports = Math.max;




//////////////////
// WEBPACK FOOTER
// ../node_modules/math-intrinsics/max.js
// module id = ../node_modules/math-intrinsics/max.js
// module chunks = 0